import React, {useState, useEffect, useRef} from 'react';
import { useDelayedTickContext } from "../../context/DelayedTickContext";
import {useStateUpdatePermission} from "../../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../../contexts/QuoteContext";

const LastTradedPriceDisplay = ({ instrumentToken, priceColor, contextName,stock,shouldUseStockForDisplay }) => {
    /*const [lastPrice, setLastPrice] = useState('0.0');*/
    const lastPriceRef = useRef('0.0');
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const delayedTickContext = useDelayedTickContext();
    const quoteContext = useQuoteContext();

    const contextData = (() => {
        switch (contextName) {
            case 'DelayedTickContext':
                return delayedTickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const delayedTick = contextData.delayedTick;

    useEffect(() => {
        if (canUpdateState) {
                lastPriceRef.current = stock.currentPrice;
        }
    }, []);

    // Fetch the last traded price and update its color
    useEffect(() => {
        if (canUpdateState && delayedTick.lastTradedPrice !== undefined) {
            if (lastPriceRef.current !== delayedTick.lastTradedPrice) {
                lastPriceRef.current = delayedTick.lastTradedPrice;
            }
        }
    }, [delayedTick.lastTradedPrice]);

    return (
        <div className="last-traded-price-pf" style={{ color: priceColor }}>
            {shouldUseStockForDisplay
                ? stock.currentPrice?.toFixed(2)
                : lastPriceRef.current ?? stock.currentPrice?.toFixed(2) ?? '0.00'}
        </div>
    );
};

export default LastTradedPriceDisplay;
